import React from "react";

export default () => {
  return (
    <div className="label-content col-lg-8">
      <h4>Reward System Settings</h4>
    </div>
  );
};
